import { useContext, useMemo } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isPWA } from '../utils/isPWA';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { dismissPWABanner, registerPushSubscription } from '../redux/pwa/actions';
import { usePushSubscription } from '../redux/pwa/hooks';
import { useSelector } from 'react-redux';
import { getIsPWABannerHidden } from '../redux/pwa/selectors';

export function usePWABanner() {
  const isMobile = useContext(MobileContext);
  const registerPush = useAction(registerPushSubscription);
  const isDismissed = useSelector(getIsPWABannerHidden);

  const { isSubscribed } = usePushSubscription();
  const isStandalone = useMemo(() => isPWA(), []);

  return {
    isSubscribed,
    isHidden: !isMobile || !isStandalone || isDismissed,
    dismiss: useAction(dismissPWABanner),
    registerPushSubscription: registerPush,
  };
}
